<template>
  <div class="back-to-top" @click.prevent="goTop">
      <button class="btn btn-primary">
          <span class="glyphicon glyphicon-chevron-up" aria-hidden="true"></span>
      </button>
  </div>
</template>

<script>
export default {
  name: 'back-to-top',
  methods: {
      goTop () {
          document.body.scrollTop = 0; 
          document.documentElement.scrollTop = 0; 
      }
  }
}
</script>

<style scoped>
.back-to-top {
  position: fixed; 
  bottom: 70px;
  right: 70px;
  cursor: pointer;
}

@media (max-width: 768px) {
  .back-to-top {
    bottom: 20px; 
    right: 20px; 
  }
}
</style>
